import {
  DisclaimerLayerOptionsV2,
  LayerManagerV27,
  LayerOptionsV2,
  RenderFunctionV2,
} from '@volkswagen-onehub/layer-manager';

import {LayerCloseHandle, OpenedLayerResult} from './layers';
import {ReactNode, useCallback, useContext} from 'react';
import { useFeatureServices } from '../use-feature-services';
import { LayerContext } from './layer-context';

export function useDisclaimerLayer(
  id: string,
  options?: LayerOptionsV2<DisclaimerLayerOptionsV2, undefined, void>
) {
  const { "layer-manager": layerManager } = useFeatureServices();
  const layerContext = useContext(LayerContext);

  return useCallback(
    (
      getLayerContent: (close: LayerCloseHandle) => ReactNode,
      onClose?: () => void,
      openLayerOptions?: Partial<
        LayerOptionsV2<DisclaimerLayerOptionsV2, undefined, void>
      >
    ) => {
      let layerResult: OpenedLayerResult;
      const render: RenderFunctionV2<undefined, void> =
        (_state, close) => (mountPoint) => {
          layerResult = {
            id,
            isOpen: true,
            getMountPoint: () => mountPoint,
            close,
            getLayerContent,
          };

          layerContext.openLayer(layerResult);
        };

      const layerOptions: LayerOptionsV2<
        DisclaimerLayerOptionsV2,
        undefined,
        void
      > = {
        userCloseable: true,
        onClose: (_state) => {
          onClose?.();
        }
      };

      (layerManager as LayerManagerV27).openDisclaimerLayer(render, undefined, {
        ...layerOptions,
        ...options,
        ...openLayerOptions,
      });
    },
    [id, layerManager, options]
  );
}
